import { RpcService } from '@holmescorp/rpc';
import { IStatement } from '../resources/istatement/statement';
import { IActor } from '../resources/istatement/actor';

interface AgentFilter {
	mbox?: string;
	mbox_sha1sum?: string;
	account?: {
		name?: string;
		homePage?: string;
	};
	openid?: string;
}

export interface StatementFilter {
	statementid?: number | string;
	statementId?: number | string;
	verb?: string;
	activity?: string;
	agent?: AgentFilter | string;
	since?: Date | string;
	until?: Date | string;
	ascending?: boolean | string;
	limit?: number | string;
	format?: string;
}

export interface IXapiSvc extends RpcService {
	get_statement(params: StatementFilter): Promise<IStatement[]>;
	set_statement(params: { stmnt: IStatement; site?: string }): Promise<any>;
	set_actor(params: { actr: IActor; site?: string }): Promise<any>;
}

export const svc: IXapiSvc = new RpcService({
	transport: 'WEBSOCKET',
	envelope: 'JSON-RPC-2.0',
	strictParameters: false,
	target: `${window.hcstatic.portal_url}/@@lrs.rpc`,

	services: {
		get_statement: {
			parameters: [
				{ name: 'statementid', type: 'number', optional: true },
				{ name: 'statementId', type: 'number', optional: true },
				{ name: 'verb', type: 'string', optional: true },
				{ name: 'activity', type: 'string', optional: true },
				{ name: 'agent', type: 'string', optional: true },
				{ name: 'since', type: 'Date', optional: true },
				{ name: 'until', type: 'Date', optional: true },
				{ name: 'ascending', type: 'boolean', optional: true },
				{ name: 'limit', type: 'number', optional: true },
				{ name: 'format', type: 'string', optional: true }
			]
		},
		set_statement: {
			parameters: [
				{
					name: 'stmnt',
					type: 'object',
					optional: false
				},
				{
					name: 'site',
					type: 'string',
					optional: true
				}
			]
		},
		set_actor: {
			parameters: [
				{
					name: 'actr',
					type: 'object',
					optional: false
				},
				{
					name: 'site',
					type: 'string',
					optional: true
				}
			]
		}
	}
}) as IXapiSvc;

export default svc;
